import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface SearchOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-search-by',
  standalone: true,
  imports: [CommonModule, MaterialModule, PipesModule, FormsModule, TranslateModule],
  templateUrl: './search-by.component.html',
  styleUrls: ['./search-by.component.scss']
})
export class SearchByComponent {
  
  @Input() selectedSearchBy: string;
  @Input() searchByOptions: SearchOption[] = []; 
  @Output() searchBySelected = new EventEmitter<string>();

  private translateService = inject(TranslateService);
  
  selectionChange(optionValue: string) {		
    this.searchBySelected.emit(optionValue);
  }
}
